import { createSelector } from 'reselect';
import { v2 } from '@saucelabs/sl-module-builds';

import { eventMetaDataSelector } from '../common/selectors';

export const builds = (store) => store.apps.builds.vdc;
export const authCheckSelector = createSelector([
  (store) => store.user,
  builds,
  (store) => store.router.location,
  (store, params = {}) => params,
],
(user, vdc, location, params) => ({
  isAuthenticated: params?.isOpenSource || user.isAuthenticated() || vdc.getIn(['build', 'public']),
  currentPathname: location.pathname,
}));

export const latestJobModifiedTime = createSelector([
  builds,
],
(vdc) => {
  const sortedJobs = vdc.get('jobs').valueSeq().sortBy((job) => job.get('modification_time'));
  return sortedJobs.size ? sortedJobs.last().get('modification_time') : null;
});

export const vdcContainerSelector = createSelector([
  builds,
  (store) => store.user,
  (store) => store.apps.builds.common,
  (store) => store.apps.builds.rootCauses,
  latestJobModifiedTime,
  eventMetaDataSelector,
],
(vdc, user, common, rootCauses, modifiedSince, eventMetaData) => ({
  isInitialized: vdc.get('initialized'),
  loading: common.get('loading'),
  jobsLoading: vdc.get('jobsLoading'),
  build: vdc.get('build'),
  jobs: vdc.get('jobs'),
  isOpenSauceUser: !user.isAuthenticated(),
  isOwner: vdc.getIn(['build', 'owner']) === user.get('username'),
  modifiedSince,
  rootCauseContribution: rootCauses.get('contribution'),
  performanceFilter: vdc.get('performanceFilter'),
  isPerformanceEnabled: user.get('performance_enabled'),
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'VDC',
  },
}));

export const jobsQueryParamSelector = createSelector([
  builds,
  latestJobModifiedTime,
  (store, params = {}) => params,
],
(vdc, modifiedSince, params) => ({
  build: vdc.get('build'),
  ...(modifiedSince ? { modified_since: modifiedSince } : null),
  ...params,
}));

export const performanceParamSelector = createSelector([
  builds,
],
(vdc) => ({
  data: {
    jobs: Object.values(vdc.get('jobs').toJS()),
  },
}));

export const getUsername = v2.buildsList.selectors.createGetUsername(builds);
export const isInitialized = v2.buildsDetail.selectors.createIsInitialized(builds);
export default vdcContainerSelector;
